import React from "react";
import { useMemoizedCallback } from "./useMemoizedCallback";

/**
 * Just like useEffect but only runs on specific dependencies.
 * Not all used variables need to be dependencies
 */
export function useDidUpdate(callback: () => void, dependencies: readonly any[]) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useEffect(callback, dependencies);
}

/**
 * Mirrors React's lifecyle function componentDidMount
 */
export function useDidMount(callback: () => void) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useEffect(callback, []);
}

/**
 * Mirrors React's lifecyle function componentWillUnmount
 */
export function useWillUnmount(callback: () => void) {
  const memoizedCallback = useMemoizedCallback(callback);
  return useDidMount(() => memoizedCallback);
}
